import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pascalcase',
  pure: true,
})
export class PascalCase implements PipeTransform {

  constructor() { }

  /**
   * Function that transform some code on html tag
   * @param value: Current value
   * @param args: Input params
   */
  public transform(value: any, args?: any): string {
    return `${String(value).charAt(0).toUpperCase()}${String(value).substr(1)}`;
  }
}
